import React, { createContext, ReactNode, useContext, useState } from 'react';

import { VERSION_1 } from '@/constant';

interface JsBridgeVersionContextType {
  version: string;
  setVersion: (version: string) => void;
}

const JsBridgeVersionContext = createContext<
  JsBridgeVersionContextType | undefined
>(undefined);

interface JsBridgeVersionProviderProps {
  children: ReactNode;
}

export const JsBridgeVersionProvider: React.FC<
  JsBridgeVersionProviderProps
> = ({ children }) => {
  const [version, setVersion] = useState<string>(VERSION_1);

  React.useEffect(() => {
    if (version === VERSION_1) {
      const script = document.createElement('script');
      script.src = import.meta.env.VITE_JSSDK_VERSION_1_URL;
      script.async = true;
      document.body.appendChild(script);

      return () => {
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
      };
    }
  }, [version]);

  return (
    <JsBridgeVersionContext.Provider value={{ version, setVersion }}>
      {children}
    </JsBridgeVersionContext.Provider>
  );
};

export const useJsBridgeVersion = (): JsBridgeVersionContextType => {
  const context = useContext(JsBridgeVersionContext);
  if (!context) {
    throw new Error(
      'useJsBridgeVersion must be used within a JsBridgeVersionProvider'
    );
  }
  return context;
};
